// @flow

import { default as Template } from './templates/template.html';
import { SelectViewModel } from './view-model';

export const COMPONENTS_SELECT_NAME = 'select';
export const COMPONENTS_SELECT_ENTITIES = [{
	name: COMPONENTS_SELECT_NAME,
	entity: SelectViewModel,
	template: Template,
}];
